export const PHONE_PATTERN = /^[+]?[0-9]{10,13}$/g;
